
import React from 'react';
import { CycleData } from '@/utils/cycle-tracking';

interface CircleCenterProps {
  cycleData: CycleData;
  highlightedDay: number | null;
}

export const CircleCenter: React.FC<CircleCenterProps> = ({ cycleData, highlightedDay }) => {
  // Get fertility status
  const getFertilityStatus = () => {
    const { currentDay } = cycleData;
    
    if (currentDay >= 11 && currentDay <= 17) {
      return { text: "High chances of getting pregnant", className: "text-amber-600 font-medium" };
    } else if (currentDay >= 6 && currentDay <= 10) {
      return { text: "Medium chances of getting pregnant", className: "text-orange-500" };
    } else {
      return { text: "Low chances of getting pregnant", className: "text-hormony-charcoal/70" };
    }
  };
  
  const fertilityStatus = getFertilityStatus();
  
  return (
    <div className="absolute inset-[70px] flex flex-col items-center justify-center text-center rounded-full bg-white z-20">
      <div className="text-4xl font-bold text-hormony-charcoal">
        {cycleData.daysUntilNextPeriod}
      </div>
      <div className="text-lg font-medium text-hormony-coral mb-2">
        Days until next period
      </div>
      <div className={`text-sm ${fertilityStatus.className} px-3 py-1 rounded-full bg-hormony-cream/30`}>
        {fertilityStatus.text}
      </div>
      
      {highlightedDay && (
        <div className="mt-3 text-sm bg-hormony-coral/10 px-3 py-1 rounded-full">
          Day {highlightedDay}: {cycleData.days.find(d => d.day === highlightedDay)?.phase || 'Unknown phase'}
        </div>
      )}
    </div>
  );
};
